'use client'

import NextError from 'next/error'
import posthog from 'posthog-js'
import { useEffect } from 'react'

export default function GlobalError({
	error,
}: { error: Error & { digest?: string }; reset: () => void }) {
	useEffect(() => {
		posthog.captureException(error)
	}, [error])

	return (
		<html lang="en">
			<body>
				{/* NextError component doesn't support omitting error code */}
				<NextError statusCode={undefined as any} />
			</body>
		</html>
	)
}
